export const initActivityRequest = (activityRef: string) => {
  return {
    mode: "activity_edit",
    reference: activityRef,
    config: {
      activity_edit: {
        mode: {
          default: "preview",
          show: false,
        },
        reference: {
          show: false,
          edit: false,
        },
        activity_preview: {
          reference: {
            show: false,
          },
        },
        back: false,
        save: {
          persist: false,
          show: false,
        },
        default_player_template: "e883731f-6fb8-43b3-992b-14f53cdf8350",
      },
    },
    user: {
      id: "demoTest",
      firstname: "",
      lastname: "",
      email: "",
    },
  };
};
